// @ts-nocheck
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface ScrollContextModel {
    scroll: number;
    setScroll: (() => void) | Dispatch<SetStateAction<number>>;
}

export const defaultContext: ScrollContextModel = {
    scroll: 0,
    setScroll: () => {},
};

export const ScrollContext = createContext<ScrollContextModel>(defaultContext);

export const useScrollContext = () => {
    const context = useContext(ScrollContext);

    if (!context) {
        throw new Error("Scroll Context is called outside a provider.");
    }

    return context;
};
